module.exports = __webpack_public_path__ + "static/img/rating-emoji-5.651da58.png";